import ApiService from './api.service'

const FormService = {

  /***
   * Get Forms
   * @returns {*}
   */
  get (rowkey) {
    return ApiService.get('form', rowkey)
  },
  /***
   * Assign form to an account
   * @param {string} slug the rowkey of the form to assign
   * @param {string} payload.account_key identifier of the account we are assigning the form to
   * @returns {*}
   */
  assign (slug, payload) {
    const params = {
      account_key: payload.account_key,
    }
    return ApiService.post(`form/${slug}/assign`, params)
  },
}
export default FormService
